import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrgGuestFeedbackCsvUploadFragment = { __typename?: 'OrgGuestFeedbackCsvUpload', id: string, fileUrl: string, feedbackDateColumn: string, feedbackTextColumn: string, ratingColumn: string, locationColumn: string, feedbackSource?: string | null, feedbacks: Array<{ __typename?: 'GuestFeedback', id: string }>, locations: Array<{ __typename?: 'OrgGuestFeedbackCsvUploadLocation', id: string, locationName: string, location: { __typename?: 'Location', id: number, name: string } }> };

export type OrgGuestFeedbackCsvUploadsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrgGuestFeedbackCsvUploadsQuery = { __typename?: 'Query', OrgGuestFeedbackCsvUploads: { __typename?: 'OrgGuestFeedbackCsvUploads', totalCount: number, objects: Array<{ __typename?: 'OrgGuestFeedbackCsvUpload', id: string, fileUrl: string, feedbackDateColumn: string, feedbackTextColumn: string, ratingColumn: string, locationColumn: string, feedbackSource?: string | null, feedbacks: Array<{ __typename?: 'GuestFeedback', id: string }>, locations: Array<{ __typename?: 'OrgGuestFeedbackCsvUploadLocation', id: string, locationName: string, location: { __typename?: 'Location', id: number, name: string } }> }> } };

export type DeleteOrgGuestFeedbackCsvUploadMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type DeleteOrgGuestFeedbackCsvUploadMutation = { __typename?: 'Mutation', deleteOrgGuestFeedbackCsvUpload: { __typename?: 'BaseMutationResult', success: boolean, error?: { __typename?: 'Error', message?: string | null } | null } };

export const OrgGuestFeedbackCsvUploadFragmentDoc = gql`
    fragment OrgGuestFeedbackCsvUpload on OrgGuestFeedbackCsvUpload {
  id
  fileUrl
  feedbackDateColumn
  feedbackTextColumn
  ratingColumn
  locationColumn
  feedbackSource
  feedbacks {
    id
  }
  locations {
    id
    locationName
    location {
      id
      name
    }
  }
}
    `;
export const OrgGuestFeedbackCsvUploadsDocument = gql`
    query OrgGuestFeedbackCsvUploads {
  OrgGuestFeedbackCsvUploads {
    objects {
      ...OrgGuestFeedbackCsvUpload
    }
    totalCount
  }
}
    ${OrgGuestFeedbackCsvUploadFragmentDoc}`;

/**
 * __useOrgGuestFeedbackCsvUploadsQuery__
 *
 * To run a query within a React component, call `useOrgGuestFeedbackCsvUploadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgGuestFeedbackCsvUploadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgGuestFeedbackCsvUploadsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgGuestFeedbackCsvUploadsQuery(baseOptions?: Apollo.QueryHookOptions<OrgGuestFeedbackCsvUploadsQuery, OrgGuestFeedbackCsvUploadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgGuestFeedbackCsvUploadsQuery, OrgGuestFeedbackCsvUploadsQueryVariables>(OrgGuestFeedbackCsvUploadsDocument, options);
      }
export function useOrgGuestFeedbackCsvUploadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgGuestFeedbackCsvUploadsQuery, OrgGuestFeedbackCsvUploadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgGuestFeedbackCsvUploadsQuery, OrgGuestFeedbackCsvUploadsQueryVariables>(OrgGuestFeedbackCsvUploadsDocument, options);
        }
export type OrgGuestFeedbackCsvUploadsQueryHookResult = ReturnType<typeof useOrgGuestFeedbackCsvUploadsQuery>;
export type OrgGuestFeedbackCsvUploadsLazyQueryHookResult = ReturnType<typeof useOrgGuestFeedbackCsvUploadsLazyQuery>;
export type OrgGuestFeedbackCsvUploadsQueryResult = Apollo.QueryResult<OrgGuestFeedbackCsvUploadsQuery, OrgGuestFeedbackCsvUploadsQueryVariables>;
export const DeleteOrgGuestFeedbackCsvUploadDocument = gql`
    mutation DeleteOrgGuestFeedbackCsvUpload($id: UUID!) {
  deleteOrgGuestFeedbackCsvUpload(id: $id) {
    success
    error {
      message
    }
  }
}
    `;
export type DeleteOrgGuestFeedbackCsvUploadMutationFn = Apollo.MutationFunction<DeleteOrgGuestFeedbackCsvUploadMutation, DeleteOrgGuestFeedbackCsvUploadMutationVariables>;

/**
 * __useDeleteOrgGuestFeedbackCsvUploadMutation__
 *
 * To run a mutation, you first call `useDeleteOrgGuestFeedbackCsvUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrgGuestFeedbackCsvUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrgGuestFeedbackCsvUploadMutation, { data, loading, error }] = useDeleteOrgGuestFeedbackCsvUploadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrgGuestFeedbackCsvUploadMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrgGuestFeedbackCsvUploadMutation, DeleteOrgGuestFeedbackCsvUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrgGuestFeedbackCsvUploadMutation, DeleteOrgGuestFeedbackCsvUploadMutationVariables>(DeleteOrgGuestFeedbackCsvUploadDocument, options);
      }
export type DeleteOrgGuestFeedbackCsvUploadMutationHookResult = ReturnType<typeof useDeleteOrgGuestFeedbackCsvUploadMutation>;
export type DeleteOrgGuestFeedbackCsvUploadMutationResult = Apollo.MutationResult<DeleteOrgGuestFeedbackCsvUploadMutation>;
export type DeleteOrgGuestFeedbackCsvUploadMutationOptions = Apollo.BaseMutationOptions<DeleteOrgGuestFeedbackCsvUploadMutation, DeleteOrgGuestFeedbackCsvUploadMutationVariables>;